<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="文本">
        <t-input v-model="attribute.title.text" size="small" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="大小">
        <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color" size="small"/>
      </t-form-item>
      <t-form-item label="位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="地图" :expand="true">
      <t-form-item label="省份">
        <t-select v-model="attribute.provinceCode" size="small" @change="changeProvince">
          <t-option label="全国" value="china"/>
          <t-option v-for="(item,index) in cityProvince" :key="index" :label="item.name" :value="item.code"/>
        </t-select>
      </t-form-item>
      <t-form-item label="城市">
        <t-select v-model="attribute.cityCode" size="small" clearable>
          <t-option v-for="(item,index) in cities" :key="index" :label="item.name" :value="item.code"/>
        </t-select>
      </t-form-item>
      <t-form-item label="指示器文本">
        <t-input size="small" v-model="attribute.seriesName"/>
      </t-form-item>
      <t-form-item label="文本颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.label.color"/>
      </t-form-item>
      <t-form-item label="文本大小">
        <t-input-number size="small" v-model="attribute.label.fontSize" :min="4" :max="100" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="边界线颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.itemStyle.borderColor"/>
      </t-form-item>
      <t-form-item label="区域颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.itemStyle.color"/>
      </t-form-item>
      <t-form-item label="柱子颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.barColor"/>
      </t-form-item>
      <t-form-item label="柱子大小">
        <t-input-number size="small" v-model="attribute.barSize" :min="0.1" :max="10" :step="0.1"/>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import cityProvince from "@/assets/map/city-province.json";
import {getChildByParentCode} from "@/utils/map-manage";
import EChartPosition from "@/components/designer/e-chart-position";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-map-3d-option",
  components: {EChartPosition,CptData},
  props: {attribute: Object,cptDataForm:Object,},
  data(){
    return {
      cityProvince,
      currentProvince:'',
      cities:[],
    }
  },
  created() {
    this.loadChild(this.attribute.provinceCode)
  },
  methods:{
    loadChild(val){
      if(val === 'china'){
        this.cities = [];
      }else{
        this.cities = getChildByParentCode(val)
      }
    },
    changeProvince(val){
      this.attribute.cityCode = ''
      this.loadChild(val)
    },
  }
}
</script>

<style scoped>

</style>
